import React from 'react'
import styled from 'styled-components'
import { useTranslation, useLang } from '../lib/i18n'

const Notice = styled.p`
    background: ${(props) => props.theme.palette.greyScale.lightestGrey};
    border-left: 3px solid ${(props) => props.theme.palette.greyScale.lightGrey};
    padding: 12px 16px;
    margin-bottom: 24px;
    font-size: 14px;
    color: ${(props) => props.theme.palette.greyScale.grey};
`

// Legal documents are published in English only; languages that need to say so
// supply the notice, and the rest leave it empty.
export default function LegalNotice() {
    const { t } = useTranslation()
    const notice = t('legalNotice')
    const lang = useLang()

    if (!notice) return null

    return <Notice lang={lang}>{notice}</Notice>
}
